import { useMemo, useCallback } from 'react';
import { Container, Flex, Box, Button } from 'theme-ui';

import { useSettings, useRouter, useBlog } from '@backpackjs/storefront';

import { Header } from './Header';
import { themed } from './BlogNav.theme';

export const BlogNav = themed(({ theme, articlePage = false }) => {
  const settings = useSettings();
  const { text } = settings?.blogSettings || {};
  const blog = useBlog();
  const router = useRouter();

  const categories = useMemo(() => {
    if (!blog?.articles?.length) return [];

    const articleCategories = blog?.articles.map((value, index) => {
      if (value.category !== '') return value.category;
    });
    return [
      ...new Set([
        ...(articleCategories?.filter((category) => category) || []),
      ]),
    ];
  }, [blog?.articles]);

  const activeCategoryLink = useMemo(() => {
    if (!router.query.category) {
      return 'All';
    }
    return categories?.find((category) => category === router.query.category);
  }, [router.query.category]);

  const handleClick = useCallback((categorySelected) => {
    const item = categories?.find((category) => category === categorySelected);
    const encoded = encodeURIComponent(item);
    const link = `articles/${
      categorySelected === 'All' ? '' : `?category=${encoded}`
    }`;
    articlePage
      ? router.replace(`/blogs/${link}`)
      : router.push(link, undefined, { shallow: true });
  });

  return (
    <Container sx={theme.wrapper}>
      {!articlePage && (
        <Box sx={theme.header}>
          <Header text={text} />
        </Box>
      )}
      <Flex sx={theme.scroll}>
        {categories &&
          ['All', ...categories].map((category, index, arr) => {
            if (!category) return null;
            const isActive = category === activeCategoryLink;
            const rightMargin = index !== arr.length - 1 ? 3 : 0;
            return (
              <Button
                variant="buttons.plain"
                key={index}
                sx={{
                  ...theme.link,
                  mr: rightMargin,
                  bg: isActive ? 'mediumGray' : theme.link.bg,
                }}
                onClick={() => handleClick(category)}
              >
                {category}
              </Button>
            );
          })}
      </Flex>
    </Container>
  );
});

BlogNav.displayName = 'BlogNav';
